import React, { useState } from "react";
import { Input, Label, Table } from "reactstrap";
import { recentSalesTableData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import { SearchTableButton } from "../../../../utils/Constant";

const RecentSalesTable = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems = recentSalesTableData.filter((item) => item.productName && item.productName.toLowerCase().includes(filterText.toLowerCase()));

  return (
    <div className='table-responsive dataTables_wrapper custom-scrollbar'>
      <div className='dataTables_filter'>
        <Label>{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type='search' value={filterText} />
      </div>
      <Table className='display' id='recent-orders' responsive>
        <thead>
          <tr>
            <th className="checkbox-checked">
              <Input type='checkbox' />
            </th>
            <th>Product Name</th>
            <th>Ordered By</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.length > 0 ? (
            <>
              {filteredItems.map((order, index) => (
                <tr key={index}>
                  <td className="checkbox-checked">
                    <Input type='checkbox' />
                  </td>
                  <td>
                    <div className='d-flex gap-2'>
                      <img src={order.productImage} alt='product' />
                      <a href='list-products.html'>
                        <span>{order.productName}</span>
                      </a>
                    </div>
                  </td>
                  <td>{order.orderedBy}</td>
                  <td>{order.quantity}</td>
                  <td>{order.price}</td>
                </tr>
              ))}
            </>
          ) : (
            <>
              <tr className='text-center'>
                <td colSpan={5}>
                  <h6>No matching records found</h6>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default RecentSalesTable;
